var _a;
/**
 * Base field for searching purposes.
 * Thee types of fields don't work on records but on fields, operators and values forming conditions
 */
var Operators = Object.freeze({
    OPERATOR_NULL: "",
    OPERATOR_GREATER_THAN: "gt",
    OPERATOR_GREATER_THAN_OR_EQUAL: "gte",
    OPERATOR_LESS_THAN: "lt",
    OPERATOR_LESS_THAN_OR_EQUAL: "lte",
    OPERATOR_EQUAL: "eq",
    OPERATOR_IS: "is",
    OPERATOR_NOT_EQUAL: "notequal",
    OPERATOR_BETWEEN: "between",
    OPERATOR_IN: "in",
    OPERATOR_NOT_IN: "notin",
    OPERATOR_STARTS_WITH: "starts",
    OPERATOR_ENDS_WITH: "ends",
    OPERATOR_CONTAINS: "contains",
    OPERATOR_IS_NULL: "isnull",
    OPERATOR_NOT_NULL: "notnull",
});
var OperatorTypes = Object.freeze({
    TYPE_NULL: "",
    TYPE_UNARY: "unary",
    TYPE_BINARY: "binary",
    TYPE_RANGE: "range",
    TYPE_LIST: "list",
});
var OperatorsDef = Object.freeze((_a = {},
    _a[Operators.OPERATOR_GREATER_THAN] = {
        value: Operators.OPERATOR_GREATER_THAN,
        label: "Supérieur(e) à",
        type: OperatorTypes.TYPE_BINARY,
    },
    _a[Operators.OPERATOR_GREATER_THAN_OR_EQUAL] = {
        value: Operators.OPERATOR_GREATER_THAN_OR_EQUAL,
        label: "Supérieur(e) ou égal(e) à",
        type: OperatorTypes.TYPE_BINARY,
    },
    _a[Operators.OPERATOR_LESS_THAN] = {
        value: Operators.OPERATOR_LESS_THAN,
        label: "Inférieur(e) à",
        type: OperatorTypes.TYPE_BINARY,
    },
    _a[Operators.OPERATOR_LESS_THAN_OR_EQUAL] = {
        value: Operators.OPERATOR_LESS_THAN_OR_EQUAL,
        label: "Inférieur(e) ou égal(e) à",
        type: OperatorTypes.TYPE_BINARY,
    },
    _a[Operators.OPERATOR_EQUAL] = {
        value: Operators.OPERATOR_EQUAL,
        label: "Egal(e) à",
        type: OperatorTypes.TYPE_BINARY,
    },
    _a[Operators.OPERATOR_IS] = {
        value: Operators.OPERATOR_EQUAL,
        label: "Est",
        type: OperatorTypes.TYPE_BINARY,
    },
    _a[Operators.OPERATOR_NOT_EQUAL] = {
        value: Operators.OPERATOR_NOT_EQUAL,
        label: "Pas egal(e) à",
        type: OperatorTypes.TYPE_BINARY,
    },
    _a[Operators.OPERATOR_STARTS_WITH] = {
        value: Operators.OPERATOR_STARTS_WITH,
        label: "Commence par",
        type: OperatorTypes.TYPE_BINARY,
    },
    _a[Operators.OPERATOR_ENDS_WITH] = {
        value: Operators.OPERATOR_ENDS_WITH,
        label: "Se termine par",
        type: OperatorTypes.TYPE_BINARY,
    },
    _a[Operators.OPERATOR_CONTAINS] = {
        value: Operators.OPERATOR_CONTAINS,
        label: "Contient",
        type: OperatorTypes.TYPE_BINARY,
    },
    _a[Operators.OPERATOR_BETWEEN] = {
        value: Operators.OPERATOR_BETWEEN,
        label: "Entre",
        type: OperatorTypes.TYPE_RANGE,
    },
    _a[Operators.OPERATOR_IN] = {
        value: Operators.OPERATOR_IN,
        label: "Fait partie de",
        type: OperatorTypes.TYPE_LIST,
    },
    _a[Operators.OPERATOR_NOT_IN] = {
        value: Operators.OPERATOR_NOT_IN,
        label: "Ne fait pas partie de",
        type: OperatorTypes.TYPE_LIST,
    },
    _a[Operators.OPERATOR_IS_NULL] = {
        value: Operators.OPERATOR_IS_NULL,
        label: "Est vide",
        type: OperatorTypes.TYPE_UNARY,
    },
    _a[Operators.OPERATOR_NOT_NULL] = {
        value: Operators.OPERATOR_NOT_NULL,
        label: "N'est pas vide",
        type: OperatorTypes.TYPE_UNARY,
    },
    _a));
export { OperatorsDef, Operators, OperatorTypes };
